(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filters"] && !Shopify.designMode) return;
  try {
    (() => {
    const toggle = document.querySelector('#collection-filters-toggle');
    const backdrop = document.querySelector('#collection-filters-backdrop');
    const drawer = document.querySelector('#collection-filters-drawer');
    const form = document.querySelector('#collection-filters-form');
    const navMenuButton = document.querySelector('#menu-button');

    if (!toggle || !backdrop || !drawer || !form) return;

    const closeButtons = [...drawer.querySelectorAll('[data-close]')];
    const clearButtons = [...drawer.querySelectorAll('[data-clear]')];
    const applyButtons = [...form.querySelectorAll('[data-apply]')];

    const checkboxes = [...form.querySelectorAll('.filter-input-checkbox')];

    const sortInputs = [...form.querySelectorAll('.filter-input-sort')];

    const defaultSort = form.dataset.defaultSort;

    let previouslyFocused;
    let navMenuButtonOriginalText;

    const isMobile = () => window.matchMedia('(max-width: 767px)').matches;

    const lockBodyScroll = () => {
      if (!isMobile()) return;

      document.documentElement.classList.add('overflow-hidden');
      document.body.classList.add('overflow-hidden');
    };

    const unlockBodyScroll = () => {
      document.documentElement.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-hidden');
    };

    const hijackNavMenuButton = () => {
      if (!navMenuButton) return;

      navMenuButtonOriginalText = navMenuButton.textContent;
      navMenuButton.textContent = 'Close';
      navMenuButton.dataset.hijacked = 'true';
    };

    const releaseNavMenuButton = () => {
      if (!navMenuButton) return;

      navMenuButton.textContent = navMenuButtonOriginalText;
      delete navMenuButton.dataset.hijacked;
    };

    const hasChanges = () => {
      const hasFilterChanges = checkboxes.some((input) => input.checked);

      const activeSort = sortInputs.find((input) => input.checked)?.value;

      const hasSortChanges = activeSort && activeSort !== defaultSort;

      return hasFilterChanges || hasSortChanges;
    };

    const updateLabels = () => {
      form.querySelectorAll('section').forEach((section) => {
        const inputs = [...section.querySelectorAll('.filter-input-checkbox')];

        const hasActive = inputs.some((input) => input.checked);

        section.querySelectorAll('.filter-option-label').forEach((label) => {
          const input = label.querySelector('input');

          label.classList.toggle('text-disabled', hasActive && !input.checked);

          label.classList.toggle('hover:text-black', hasActive && !input.checked);

          label.classList.toggle('!text-black', !hasActive || input.checked);

          label.classList.toggle('hover:text-disabled', !hasActive || input.checked);
        });
      });

      const activeSort = sortInputs.find((input) => input.checked)?.value;

      const hasNonDefaultSort = activeSort && activeSort !== defaultSort;

      form.querySelectorAll('.sort-option-label').forEach((label) => {
        const input = label.querySelector('input');

        label.classList.toggle('text-disabled', hasNonDefaultSort && !input.checked);

        label.classList.toggle('hover:text-black', hasNonDefaultSort && !input.checked);

        label.classList.toggle('!text-black', !hasNonDefaultSort || input.checked);

        label.classList.toggle('hover:text-disabled', !hasNonDefaultSort || input.checked);
      });
    };

    const updateActions = () => {
      const changed = hasChanges();

      applyButtons.forEach((button) => {
        button.disabled = !changed;
      });

      clearButtons.forEach((button) => {
        button.disabled = !changed;
      });

      updateLabels();
    };

    const open = () => {
      previouslyFocused = document.activeElement;

      backdrop.classList.remove('hidden');
      backdrop.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');

      lockBodyScroll();
      hijackNavMenuButton();

      drawer.querySelector('button, input, [href], select, textarea, [tabindex]:not([tabindex="-1"])')?.focus();
    };

    const closeDrawer = () => {
      backdrop.classList.add('hidden');
      backdrop.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');

      unlockBodyScroll();
      releaseNavMenuButton();

      previouslyFocused?.focus();
    };

    const clearAll = () => {
      checkboxes.forEach((input) => {
        input.checked = false;
      });

      const defaultSortInput = sortInputs.find((input) => input.value === defaultSort);

      if (defaultSortInput) {
        defaultSortInput.checked = true;
      } else {
        sortInputs.forEach((input) => {
          input.checked = false;
        });
      }

      updateActions();
      closeDrawer();
      form.requestSubmit();
    };

    toggle.addEventListener('click', () => {
      toggle.getAttribute('aria-expanded') === 'true' ? closeDrawer() : open();
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', closeDrawer);
    });

    clearButtons.forEach((button) => {
      button.addEventListener('click', clearAll);
    });

    backdrop.addEventListener('click', (event) => {
      if (event.target === backdrop) {
        closeDrawer();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !backdrop.classList.contains('hidden')) {
        closeDrawer();
      }
    });

    window.addEventListener('mobile-menu-hijacked-click', closeDrawer);

    form.addEventListener('input', updateActions);

    window.addEventListener('resize', () => {
      if (backdrop.classList.contains('hidden')) return;

      if (isMobile()) {
        lockBodyScroll();
      } else {
        unlockBodyScroll();
      }
    });

    updateActions();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    function setCartStatus(card, message) {
    var status = card && card.querySelector('[data-cart-status]');
    if (status) {
      status.textContent = message;
    }
  }

  document.addEventListener('click', function (event) {
    var quickAdd = event.target.closest('[data-quick-add]');
    var card = quickAdd && quickAdd.closest('[data-product-card]');
    var variantId =
      card &&
      (card.querySelector('[data-size-input]:checked:not(:disabled)')?.dataset.variantId ||
        quickAdd.dataset.defaultVariantId);
    var cartDrawer = document.querySelector('cart-drawer');

    if (
      !quickAdd ||
      quickAdd.dataset.loading === 'true' ||
      !card ||
      !variantId ||
      !cartDrawer ||
      typeof cartDrawer.addObjectToCart !== 'function'
    ) {
      return;
    }

    var productTitle = card.dataset.productTitle || 'item';

    quickAdd.dataset.loading = 'true';
    quickAdd.setAttribute('aria-busy', 'true');
    setCartStatus(card, 'Adding ' + productTitle + ' to cart.');

    cartDrawer
      .addObjectToCart({
        id: Number(variantId),
        quantity: 1,
      })
      .then(function () {
        setCartStatus(card, productTitle + ' added to cart.');
      })
      .catch(function (error) {
        console.error('Quick add failed:', error);
        setCartStatus(card, 'Unable to add ' + productTitle + ' to your cart.');
      })
      .finally(function () {
        quickAdd.dataset.loading = 'false';
        quickAdd.removeAttribute('aria-busy');
      });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["site-credit"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.site-credit__trigger').forEach((button) => {
    const parent = button.closest('[data-site-credit-mobile]');
    if (!parent) return;

    const setExpanded = (expanded) => {
      parent.setAttribute('aria-expanded', String(expanded));
    };

    button.addEventListener('click', (event) => {
      console.log('click');
      event.stopPropagation();
      const isOpen = parent.getAttribute('aria-expanded') === 'true';
      setExpanded(!isOpen);
    });

    document.addEventListener('click', (event) => {
      if (!parent.contains(event.target)) {
        setExpanded(false);
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
